import { useState } from "react";

import {
  ExpandLess as ExpandLessIcon,
  ExpandLessOutlined,
  ExpandMore as ExpandMoreIcon,
  ExpandMoreOutlined,
} from "@mui/icons-material";
import { Box, Collapse, IconButton } from "@mui/material";
import { ValueLabel } from "mui-toolkit/ValueLabel";

import KPICalculationTable from "./KPICalculationTable";

const ValueLabelWithCalculation = ({ label, value, isLoading, calculation, ...otherProps }) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Box sx={{ flex: "0 0 auto" }}>
          <ValueLabel label={label} value={value} isLoading={isLoading} {...otherProps} />
        </Box>
        {calculation && (
          <IconButton
            onClick={handleExpandClick}
            size="small"
            sx={{
              ml: 0.5,
              padding: "4px",
              "& .MuiSvgIcon-root": { fontSize: "1.2rem" },
            }}
            aria-expanded={expanded}
            aria-label="show calculation"
          >
            {expanded ? <ExpandLessOutlined /> : <ExpandMoreOutlined />}
          </IconButton>
        )}
      </Box>
      {calculation && (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <KPICalculationTable calculation={calculation} />
        </Collapse>
      )}
    </Box>
  );
};

export default ValueLabelWithCalculation;
